function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { baseFetch, URL_BASE } from "../base-fetch";
const fetchData = function() {
    var _ref = _async_to_generator(function*(url, body, method = "POST", timeout) {
        const controller = new AbortController();
        const signal = controller.signal;
        const timeoutId = timeout ? setTimeout(()=>controller.abort(), timeout) : null;
        try {
            const response = yield baseFetch(url, _object_spread_props(_object_spread({
                method,
                headers: {
                    "Content-Type": "application/json"
                }
            }, body !== undefined && {
                body: JSON.stringify(body)
            }), {
                signal
            }));
            if (!response.ok) {
                const errorText = yield response.text();
                throw new Error(`HTTP error ${response.status}: ${errorText}`);
            }
            return yield response.json();
        } finally{
            timeoutId && clearTimeout(timeoutId);
        }
    });
    return function fetchData(url, body) {
        return _ref.apply(this, arguments);
    };
}();
export const isBC = function() {
    var _ref = _async_to_generator(function*(email, timeout) {
        return yield fetchData(`${URL_BASE}/contact-sales/bc-qualify`, {
            email,
            timeout
        });
    });
    return function isBC(email, timeout) {
        return _ref.apply(this, arguments);
    };
}();
export const getContactFlow = function() {
    var _ref = _async_to_generator(function*(details, timeout) {
        return yield fetchData(`${URL_BASE}/contact-sales/contact-flow`, details, "POST", timeout);
    });
    return function getContactFlow(details, timeout) {
        return _ref.apply(this, arguments);
    };
}();
export const getAeChilipiperLink = function() {
    var _ref = _async_to_generator(function*() {
        return yield fetchData(`${URL_BASE}/contact-sales/ae-chilipiper`, undefined, "GET");
    });
    return function getAeChilipiperLink() {
        return _ref.apply(this, arguments);
    };
}();
